/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}


.content-right {
  @apply flex-row-reverse;
}

.content-left {
  @apply flex-row;
}

.ping-pong-container {
  @apply w-full h-auto flex flex-col-reverse md:flex-row items-center justify-between gap-x-[48px] gap-y-[24px] relative;
}

.ping-pong-container.content-right {
  @apply md:flex-row-reverse;
}

.ping-pong-container .ping-pong-content {
  @apply w-full h-full py-24px relative max-w-[750px];
}

.ping-pong-container .ping-pong-title {
  @apply w-fit h-auto font-poppins fs-4 font-semibold;
}

.ping-pong-container .ping-pong-description {
  @apply w-fit h-auto font-poppins fs-2 mt-20px;
}

.ping-pong-container .ping-pong-description a {
  @apply text-medium-blue hover:text-dark-blue transition-colors underline;
}

.ping-pong-container .ping-pong-buttons {
  @apply w-fit h-auto flex justify-start items-center gap-12px mt-20px md:mt-40px;
}

.ping-pong-container .ping-pong-asset-wrapper {
  @apply w-full h-full aspect-video relative overflow-hidden md:max-w-[900px];
}

.ping-pong-container .ping-pong-asset-wrapper iframe {
  @apply w-full h-full aspect-video rounded-xl;
}

.ping-pong-container .ping-pong-asset {
  @apply w-full h-auto object-cover rounded-[12px] max-h-[400px] md:max-h-[100%];
}

@keyframes swipe-in {
  0% {
    /* filter: grayscale(100%); */
    left: 0;
  }
  100% {
    /* filter: grayscale(0); */
    left: 100%;
    opacity: 0;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1, .overlay2 {
  @apply bg-white absolute w-full h-full top-0 left-0 z-10 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.overlay1.bg-dark-blue,
.overlay2.bg-dark-blue {
  background-color: var(--dark-blue);
}

.ping-pong-container.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: 0.15s;
  }
  
  .ping-pong-container.animate .overlay2 {
    animation-name: fade-in;
    animation-delay: 0s;
  }

@media (min-width: 1000px) {
  .ping-pong-container.animate .overlay1 {
    animation-name: fade-in;
    animation-delay: 0s;
  }
  
  .ping-pong-container.animate .overlay2 {
    animation-name: fade-in;
    animation-delay: 0.15s;
  }

}


.ping-pong-container.animate.content-right .overlay1 {
  animation-name: fade-in;
  animation-delay: 0.15s;
}

.ping-pong-container.animate.content-right .overlay2 {
  animation-name: fade-in;
  animation-delay: 0s;
}